import { authenticateRequest } from '@api/authenticateRequest';

interface ToggleFamilyEventSmsData {
  enabled: boolean;
}

interface ToggleFamilyEventSmsResponse {
  enabled: boolean;
}

interface ToggleFamilyEventSmsProps {
  data: ToggleFamilyEventSmsData;
}

export async function toggleFamilyEventSms({
  data,
}: ToggleFamilyEventSmsProps): Promise<ToggleFamilyEventSmsResponse | false> {
  const response = await authenticateRequest<ToggleFamilyEventSmsResponse>({
    method: 'post',
    url: '/api/v1/admin/events/sms-toggle',
    data,
  });

  console.log('toggleFamilyEventSms', { response });
  return response;
}

export type { ToggleFamilyEventSmsData, ToggleFamilyEventSmsResponse };
